import React, { Dispatch, SetStateAction } from 'react'

import { Box, Typography } from '@mui/material'

import { styles } from './AgreedTermsCheckbox.styles'

export const TEST_ID = 'agreed-terms-checkbox'

export interface Props {
	gameId?: string
	setTermsAgreed: Dispatch<SetStateAction<boolean>>
	termsAgreed: boolean
}

const AgreedTermsCheckbox = (props: Props) => {
	const handleCheckbox = () => {
		props.setTermsAgreed(!props.termsAgreed)
	}

	return (
		<>
			{props.gameId && (
				<Box sx={styles.gameIdBox}>
					<input
						type="checkbox"
						checked={props.termsAgreed}
						onChange={handleCheckbox}
						data-testid={`${TEST_ID}__term_agreement_checkbox`}
						style={styles.termsAgreedCheckbox}
					/>
					<Typography
						data-testid={`${TEST_ID}__term_agreement_text`}
						sx={styles.termsAgreedLabel}
					>
						I understand my submitted ideas are only visible to me
						and the game creator.
					</Typography>
				</Box>
			)}
		</>
	)
}

export default AgreedTermsCheckbox
